

































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TypeLink from './TypeLink.vue';
import NodeDetails, { NodeDetailsVo } from './NodeDetails.vue';
import utils, { DbLogItf } from '../../../../common/utils';
import { SVG_PATH } from '../../../../constant';
import forceStore, {
    State,
    NodeVo,
    LinkVo,
    CategoryVo
} from '../../../../store/nexus';
import SearchStore from '../../../../store/SearchStore';

import * as d3 from 'd3';
@Component({
    components: {
        TypeLink,
        NodeDetails
    }
})
export default class Map extends Vue {
    g: any;
    svg: any;
    zoom: any;
    gNodes: any;
    gLinks: any;
    svgNodes: any;
    simulation: any;
    fps: number = 0;
    loading: HTMLElement;
    isZoom: boolean = true;
    curNode: any;
    activeId!: any;
    svgRelationships: any;
    stage!: HTMLDivElement;
    stageRect!: DOMRect;
    forceDataSource = forceStore.dataSource;
    nodes: Array<NodeVo> = [];
    links: Array<LinkVo> = [];
    dbLog: DbLogItf = utils.dbLog();
    svgWidth: number = 0;
    svgHeight: number = 0;
    styleObject: { height?: string } = {};
    isSwitch: boolean = false;
    isfullScreen: boolean = false;
    stageFinance: HTMLDivElement;
    loadingEnd: boolean = false;
    rootLock: boolean = true;
    // subjectId: string = '1008943117245653414'; // '1008943072559509726';
    subjectId: string = '';
    tipsStore: NodeDetailsVo = {
        x: 0,
        y: 0,
        size: 0,
        lock: false,
        title: [],
        isType: 'node',
        activation: false,
        userInfoVoList: []
    };
    searchData = SearchStore.state;
    get searchItem() {
        return this.searchData['searchItem'];
    }
    createSimulation() {
        this.simulation = d3
            .forceSimulation()
            .force(
                'collide',
                d3
                    .forceCollide()
                    .radius((d: NodeVo) => {
                        // 根据值设定半径
                        return d.style.size + 30;
                    })
                    .iterations(8)
                    .strength(0.05) // 布局迭代次数
            )
            //    .force('charge', d3.forceManyBody().strength((d: NodeVo) => {
            //                 if (d.id !== forceStore.rootSubjectId) {
            //                     return -800;
            //                 }
            //                 return 0;
            //             }).distanceMin(100))
            .force('charge', d3.forceManyBody().distanceMin(10))
            .force(
                'link',
                d3.forceLink().id((d: any) => {
                    return d.id;
                })
            )
            .force(
                'center',
                d3.forceCenter(this.svgWidth / 2, this.svgHeight / 2)
            )
            .on('tick', this.tick.bind(this));
    }
    hideNode(node: any) {
        const size: number = this.links.length;
        const links: Array<any> = [];
        for (let i = size - 1; i > -1; i--) {
            let link: any = this.links[i];
            if (link.source.id === node.id) {
                links.push(this.links.splice(i, 1)[0]);
            }
        }
        this.dbLog.set('del', node.id, {
            links
        });
        this.onUpSimulation();
    }
    createZoom() {
        const offset: {
            x: number;
            y: number;
        } = {
            x: 0,
            y: 0
        };
        this.zoom = d3
            .zoom()
            .scaleExtent([0.5, 4])
            // .on('start', () => {
            //     this.isHide();
            //     this.tick();
            // })
            .on('zoom', () => {
                const x = d3.event.transform.x;
                const y = d3.event.transform.y;
                const scale = d3.event.transform.k;
                const transform = `translate(${x}px, ${y}px) scale(${scale})`;
                this.g.style('transform', transform);
            });
        // .on('end', () => {
        //     this.isHide();
        //     this.tick();
        // });
    }
    isHide() {
        let x: number = 0;
        let y: number = 0;
        const sw = this.stageRect.width / 0.6;
        const sh = this.stageRect.height / 0.6;
        let scale = 1;
        if (d3.event && d3.event.transform) {
            x = d3.event.transform.x;
            y = d3.event.transform.y;
            scale = d3.event.transform.k;
        }
        this.nodes.forEach((vo: NodeVo) => {
            const sx = vo.x * scale + x - sw;
            const sy = vo.y * scale + y - sh;
            vo.zoomSize = 1;
            if (Math.abs(sx) > sw || Math.abs(sy) > sh) {
                vo.zoomSize = 0;
                // vo.zoomSize = Math.sqrt(sx * sx + sy * sy);
            }
        });
        // console.log('可视区之外的节点有', this.nodes.length, sum);
    }
    tick() {
        if (this.gNodes && this.gLinks) {
            // this.isHide();
            // this.gNodes.each((node: NodeVo) => {
            //     const dom: SVGElement = node.el;
            //     if (node.zoomSize === 1) {
            //         dom.style.display = 'block';
            //         dom.style.transform = `translate(${node.x}px, ${node.y}px)`;
            //         if (this.rootLock && node.id === forceStore.rootSubjectId) {
            //             node.fx = this.svgWidth / 2;
            //             node.fy = this.svgHeight / 2;
            //         }
            //     } else {
            //         dom.style.display = 'none';
            //     }
            // });
            this.gNodes.style('transform', (d: NodeVo) => {
                if (this.rootLock && d.id === forceStore.rootSubjectId) {
                    d.fx = this.svgWidth / 2;
                    d.fy = this.svgHeight / 2;
                }
                return `translate(${d.x}px, ${d.y}px)`;
            });
            this.gLinks.each(function(data: LinkVo) {
                const link: any = d3.select(this);
                const x1 = data.source.x;
                const y1 = data.source.y;
                const x2 = data.target.x;
                const y2 = data.target.y;
                const x = x2 - x1;
                const y = y2 - y1;
                const dr = Math.sqrt(x * x + y * y);
                const sourceSize = data.source.style.size + 16;
                const targetSize = data.target.style.size + 16;
                const angle = (Math.atan2(y, x) * 180) / Math.PI;
                const radians = (Math.PI / 180) * angle;
                const nx = Math.cos(radians) * targetSize;
                const ny = Math.sin(radians) * targetSize;
                const width = Math.sqrt(
                    Math.pow(x - nx, 2) + Math.pow(y - ny, 2)
                );
                const mirror = Math.abs(angle) > 90 && Math.abs(angle) < 270;
                link.style('display', (d: LinkVo) => {
                    return 'block';
                });
                link.style('transform', (d: LinkVo) => {
                    return `translate(${x1}px, ${y1}px) rotate(${angle}deg)`;
                })
                    .select('.path')
                    .attr('d', (d: any) => {
                        const fx = width - 8;
                        const size: number = sourceSize + 0;
                        return `M${size},0 A${dr},${dr} 0 0,1 ${width},0`;
                    });
                if (data.edgePropertyVoList.length) {
                    link.select('.hotpath').attr('d', (d: any) => {
                        const fx = width - 8;
                        const size: number = sourceSize + 0;
                        return `M${size},0 A${dr},${dr} 0 0,1 ${width},0`;
                    });
                }
                link.select('text').style('transform', function(d: any) {
                    const x = (width - sourceSize) / 2 + sourceSize;
                    const y = mirror ? -3.5 : 3.5;
                    const rotate = mirror ? 180 : 0;
                    return `translate(${x}px, ${y}px) rotate(${rotate}deg)`;
                });
                // if (data.source.zoomSize === 1 || data.target.zoomSize === 1) {
                //     const x1 = data.source.x;
                //     const y1 = data.source.y;
                //     const x2 = data.target.x;
                //     const y2 = data.target.y;
                //     const x = x2 - x1;
                //     const y = y2 - y1;
                //     const dr = Math.sqrt(x * x + y * y);
                //     const sourceSize = data.source.style.size + 16;
                //     const targetSize = data.target.style.size + 16;
                //     const angle = (Math.atan2(y, x) * 180) / Math.PI;
                //     const radians = (Math.PI / 180) * angle;
                //     const nx = Math.cos(radians) * targetSize;
                //     const ny = Math.sin(radians) * targetSize;
                //     const width = Math.sqrt(
                //         Math.pow(x - nx, 2) + Math.pow(y - ny, 2)
                //     );
                //     const mirror =
                //         Math.abs(angle) > 90 && Math.abs(angle) < 270;
                //     link.style('display', (d: LinkVo) => {
                //         return 'block';
                //     });
                //     link.style('transform', (d: LinkVo) => {
                //         return `translate(${x1}px, ${y1}px) rotate(${angle}deg)`;
                //     })
                //         .select('.path')
                //         .attr('d', (d: any) => {
                //             const fx = width - 8;
                //             const size: number = sourceSize + 0;
                //             return `M${size},0 A${dr},${dr} 0 0,1 ${width},0`;
                //         });
                //     link.select('.hotpath').attr('d', (d: any) => {
                //         const fx = width - 8;
                //         const size: number = sourceSize + 0;
                //         return `M${size},0 A${dr},${dr} 0 0,1 ${width},0`;
                //     });
                //     link.select('text').style('transform', function(d: any) {
                //         const x = (width - sourceSize) / 2 + sourceSize;
                //         const y = mirror ? -3.5 : 3.5;
                //         const rotate = mirror ? 180 : 0;
                //         return `translate(${x}px, ${y}px) rotate(${rotate}deg)`;
                //     });
                // } else {
                //     link.style('display', (d: LinkVo) => {
                //         return 'none';
                //     });
                // }
            });
        }
    }
    createLink() {
        this.gLinks = this.svgRelationships.selectAll('g').data(this.links);
        this.gLinks.exit().remove(); // 删除多余连线
        const seif: any = this;
        const enter = this.gLinks
            .enter()
            .append('g')
            .attr('class', function(d: LinkVo) {
                d.el = this;
                return 'relationship';
            });
        this.gLinks = enter.merge(this.gLinks);
        this.gLinks.each(function(d: LinkVo) {
            const link: any = d3.select(this);
            d.el = this;
            link.html('');
            link.append('path').attr('class', 'path');
            if (d.edgePropertyVoList.length) {
                link.append('path').attr('class', 'hotpath');
                link.on('mouseenter', (vo: any) => {
                    if (!seif.tipsStore.lock) {
                        seif.tipsStore.x = d3.event.offsetX;
                        seif.tipsStore.y = d3.event.offsetY;
                        seif.tipsStore.size = 0;
                        seif.tipsStore.isType = 'link';
                        seif.tipsStore.title = forceStore.linkTitle(vo);
                        seif.tipsStore.userInfoVoList = d.edgePropertyVoList;
                        seif.tipsStore.activation = true;
                        forceStore.lightLink(vo);
                    }
                });
                link.on('mouseleave', (d: any) => {
                    if (forceStore.quCache) {
                        forceStore.quLighting();
                    } else {
                        forceStore.lightAllNode('1');
                    }
                    seif.tipsStore.activation = false;
                });
            }
            link.append('text')
                .attr('class', 'text')
                .text((d: any) => {
                    return d.title;
                });
        });
    }
    createNode() {
        this.gNodes = this.svgNodes
            .selectAll('g')
            .data(this.nodes, (d: NodeVo) => {
                return d.id;
            });
        this.gNodes.exit().remove(); // 删除多余连线
        const stage: HTMLElement = this.stage;
        const seif: any = this;
        const icoTray = (node: any) => {
            node.select('.ico_expand').attr('d', (d: NodeVo) => {
                const type: number = forceStore.isNetwork(d.id);
                if (type > 0) {
                    // 节点全部展开图标显示收起
                    return SVG_PATH['ICO.Reverse'];
                }
                return SVG_PATH['ICO.Expand'];
            });
        };
        const enter = this.gNodes
            .enter()
            .append('g')
            .style('transform', (d: NodeVo) => {
                return `translate(${d.x}px, ${d.y}px)`;
            })
            .attr('class', (d: NodeVo) => {
                let className = 'node';
                if (d.isClick) {
                    className += ' click';
                }
                if (d.highlight) {
                    className += ' flash';
                }
                return className;
            })
            .on('click', (d: NodeVo) => {
                if (d.isClick) {
                    forceStore.swapCurNode(d.id);
                }
            }) // 收起子节点
            .call(
                d3
                    .drag()
                    .on('start', (d: any) => {
                        this.simulation.alphaTarget(0.04).restart();
                        d.fx = d.x;
                        d.fy = d.y;
                        if (d.id === forceStore.rootSubjectId) {
                            this.rootLock = false;
                            d.fx = d.x;
                            d.fy = d.y;
                        }
                        this.tipsStore.activation = false;
                        this.tipsStore.lock = true;
                    })
                    .on('drag', (d: any) => {
                        d.fx = d3.event.x;
                        d.fy = d3.event.y;
                        this.tipsStore.lock = true;
                    })
                    .on('end', (d: any) => {
                        this.simulation.alphaTarget(0);
                        this.tipsStore.lock = false;
                        // d.fx = null;
                        // d.fy = null;
                        // forceStore.freezeNode();
                    })
            );
        this.gNodes = enter.merge(this.gNodes);
        this.gNodes.each(function(data: NodeVo) {
            const node: any = d3.select(this);
            const size: number = data.style.size + 10;
            data.el = this;
            if (data.id === forceStore.curSubjectId) {
                node.attr('id', 'root');
            }
            node.html('');
            node.append('text')
                .attr('class', 'text')
                .text((d: NodeVo) => {
                    return d.title.slice(0, 12);
                })
                .style('transform', (d: NodeVo) => {
                    const ty: number = d.style.size + 20;
                    return `translate(0px,${ty}px)`;
                });
            // 文字超出监听移入移除事件
            node.on('mouseenter', (d: NodeVo) => {
                const nodeRect: DOMRect = this.querySelector(
                    data.isClick ? '.ring' : '.icon'
                ).getBoundingClientRect();
                const stageRect = stage.getBoundingClientRect() as DOMRect;
                const h: number = nodeRect.height / 2;
                const w: number = nodeRect.width;
                const x: number = nodeRect.x - stageRect.x + w;
                const y: number = nodeRect.y - stageRect.y + h;
                node.select('text').text((d: NodeVo) => {
                    return d.title;
                });
                icoTray(node);
                forceStore.lightNode(d.id);
                if (
                    d.isLink !== 'CVT' &&
                    d.userInfoVoList.length &&
                    !seif.tipsStore.lock
                ) {
                    seif.tipsStore.x = x;
                    seif.tipsStore.y = y;
                    seif.tipsStore.size = w;
                    seif.tipsStore.title = [d.title];
                    seif.tipsStore.isType = 'node';
                    seif.tipsStore.userInfoVoList = d.userInfoVoList;
                    seif.tipsStore.activation = true;
                }
            });
            node.on('mouseleave', (d: any) => {
                node.select('text').text((d: NodeVo) => {
                    return d.title.slice(0, 12);
                });
                if (forceStore.quCache) {
                    forceStore.quLighting();
                } else {
                    forceStore.lightAllNode('1');
                }
                forceStore.quLighting();
                if (d.userInfoVoList.length) {
                    seif.tipsStore.activation = false;
                }
            });
            if (data.isClick) {
                node.append('circle')
                    .attr('r', (d: NodeVo) => {
                        if (d.id === forceStore.rootSubjectId) {
                            return d.style.size + 30;
                        }
                        return d.style.size + 20;
                    })
                    .attr('class', 'ring')
                    .style('fill', (d: NodeVo) => {
                        return d.style.stroke;
                    });
            }
            node.append('circle')
                .attr('r', (d: any) => {
                    return d.style.size + 4;
                })
                .style('fill', (d: NodeVo) => {
                    return `rgba(204,248,255,0.20)`;
                })
                .attr('class', (d: NodeVo) => {
                    return `animation-a ${data.isClick ? 'light' : ''}`;
                });
            if (data.highlight) {
                node.append('circle')
                    .attr('r', (d: any) => {
                        return d.style.size + 4;
                    })
                    .style('fill', (d: NodeVo) => {
                        return `rgba(204,248,255,0.20)`;
                    })
                    .attr('class', (d: NodeVo) => {
                        return `animation-b ${data.isClick ? 'light' : ''}`;
                    });
            }
            node.append('image')
                .attr('class', 'icon')
                .attr('width', (d: NodeVo) => {
                    return d.style.size * 2;
                })
                .attr('height', (d: NodeVo) => {
                    return d.style.size * 2;
                })
                .attr('href', (d: NodeVo) => {
                    if (d.id === forceStore.curSubjectId) {
                        return forceStore.icon[data.type].hover;
                    }
                    return forceStore.icon[data.type].normal;
                })
                .style('transform', (d: NodeVo) => {
                    const size: number = -d.style.size;
                    return `translate(${size}px,${size}px)`;
                });
            if (data.isClick) {
                let size: number = data.style.size;
                if (data.id !== forceStore.rootSubjectId) {
                    size = data.style.size - 8;
                }
                const scale: number = Math.min(Math.max(size / 20, 0.8), 1);
                const ty: number = 9 * scale;
                const tx: number = 9 + size + 15;
                node.append('path')
                    .attr('d', SVG_PATH['ICO.Expand'])
                    .attr('class', 'ico_expand')
                    .style('fill', (d: NodeVo) => {
                        return d.style.color;
                    })
                    .style('transform', (d: NodeVo) => {
                        return `translate(${-tx}px,${-ty}px) scale(${scale})`;
                    });
                node.append('rect')
                    .attr('class', 'rect')
                    .style('transform', (d: NodeVo) => {
                        return `translate(${-tx}px,${-ty}px) scale(${scale})`;
                    })
                    .on('click', (d: NodeVo) => {
                        // 点击进行节点操作
                        forceStore.freezeNode(d, false);
                        forceStore.appendNode(d.id);
                        icoTray(node);
                    });
                // node
                //     .append('path')
                //     .attr('d', SVG_PATH['ICO.Hide'])
                //     .attr('class', 'ico_hide')
                //     .style('transform', (d: NodeVo) => {
                //         return `translate(${tx1}px,${-ty}px) scale(${scale})`;
                //     });
            }
        });
    }
    createMap() {
        this.createZoom();
        this.svg = d3
            .select(this.stage)
            .select('svg')
            .call(this.zoom)
            .on('wheel', () => {
                d3.event.preventDefault();
            })
            .on('dblclick.zoom', null)
            .on('click.zoom', null);
        this.g = this.svg.select('g').html('');
        this.svgRelationships = this.g
            .append('g')
            .attr('class', 'relationships');
        this.svgNodes = this.g.append('g').attr('class', 'nodes');
        this.createSimulation();
        this.onUpSimulation();
    }
    onUpSimulation() {
        this.createNode();
        this.createLink();
        this.simulation
            .nodes(this.nodes)
            .force('link')
            .links(this.links);
        this.simulation.alpha(0.1).restart();
    }
    refreshMap(version: string) {
        this.loadingEnd = false;
        this.nodes = forceStore.groupNode();
        this.links = forceStore.groupLink();
        this.onUpSimulation();
        setTimeout(() => {
            this.loading.style.opacity = '0';
        }, 100);
    }
    @Watch('searchItem')
    searchItemChange(newSearchItem, oldSearchItem) {
        if (
            newSearchItem.className === 'People.User' ||
            newSearchItem.customType === 'user'
        ) {
            let { subjectId } = newSearchItem;
            this.subjectId = subjectId; // '1008943020835385549';
            this.sendRelationMap(this.subjectId);
        }
    }

    sendRelationMap(subjectId: string) {
        this.resetForceGraph();
        this.isZoom = false;
        this.updataInit();
        if (forceStore.rootSubjectId) {
            forceStore.reset();
        }
        forceStore.request({
            pointNum: forceStore.pointNum,
            edgeLevel: forceStore.edgeLevel,
            subjectId: subjectId
        });
        this.rootLock = true;
    }
    onUpActive(active?: boolean) {
        const clientHeight: number = document.documentElement.clientHeight;
        this.stageRect = this.stage.getBoundingClientRect() as DOMRect;
        this.svgHeight = clientHeight - this.stageRect.top;
        this.svgWidth = this.stageRect.width;
        this.styleObject = {
            height: `${this.svgHeight}px`
        };
    }
    witchChange() {
        const svg: HTMLElement = document.querySelector(
            '.neo4jd3'
        ) as HTMLElement;
        if (this.isSwitch) {
            svg.classList.remove('show-text');
        } else {
            svg.classList.add('show-text');
        }
    }
    zoomIn() {
        this.zoom.scaleBy(this.svg, 1.2);
    }

    zoomOut() {
        this.zoom.scaleBy(this.svg, 0.8);
    }
    resetForceGraph() {
        this.zoom.scaleTo(this.svg, 1);
        this.zoom.translateTo(this.svg, this.svgWidth / 2, this.svgHeight / 2);
    }
    fullScreen() {
        this.isfullScreen = !this.isfullScreen;
        if (this.isfullScreen) {
            this.stageFinance.classList.add('finance-screen');
        } else {
            this.stageFinance.classList.remove('finance-screen');
        }
        window.requestAnimationFrame(() => {
            this.onUpActive();
        });
    }
    updataInit() {
        this.loadingEnd = false;
        this.loading.style.opacity = '1';
        this.loading.style.visibility = 'visible';
    }
    mounted() {
        this.stageFinance = document.querySelector('.full-page-view-finance');
        this.stage = this.$refs.stage as HTMLDivElement;
        this.loading = this.$refs.loading as HTMLDivElement;
        this.loading.addEventListener('transitionend', () => {
            if (!this.loadingEnd) {
                this.loading.style.visibility = 'hidden';
                this.loading.style.opacity = '1';
                this.isZoom = true;
                this.loadingEnd = true;
            }
        });
        this.activeId = this.onUpActive.bind(this);
        (window as any).addEventListener('resize', this.activeId);
        this.$nextTick(() => {
            this.onUpActive();
            this.createMap();
            // 默认情况下不会有subject
            if (this.subjectId) {
                this.sendRelationMap(this.subjectId);
            }
        });
        forceStore.on(forceStore.EVENT_UP_DATA, this.refreshMap.bind(this));
        forceStore.on(forceStore.EVENT_UP_INIT, this.updataInit.bind(this));
    }
    beforeDestroy() {
        forceStore.reset();
        (window as any).removeEventListener('resize', this.activeId);
    }
}
